import classNames from 'classnames';
import React, { useState } from 'react';
import { InputNumber, SelectAngle } from '@meitu/saas-ui';
import './index.less';

interface IAngleInputGroup {
    angle: number;
    disabled?: boolean;
    min?: number;
    max?: number;
    precision?: number;
    onAdjustAngle: (val: number) => void;
    onAdjustAngleAfter: (val: number) => void;
}
const AngleInputGroup: React.FC<IAngleInputGroup> = (props) => {
    const { angle, disabled = false, min = -180, max = 180, precision = 1, onAdjustAngle, onAdjustAngleAfter } = props;

    const [isActive, setIsActive] = useState<boolean>(false);
    return (
        <div
            className={classNames('angle-input-group', {
                'angle-input-group--disabled': disabled,
                'angle-input-group--active': isActive,
            })}
        >
            <SelectAngle
                angle={~~angle}
                showValue={false}
                onChange={(angle) => {
                    if (!isActive) setIsActive(true);
                    onAdjustAngle(angle);
                }}
                onAfterChange={(angle) => {
                    setIsActive(false);
                    onAdjustAngleAfter(angle);
                }}
            />
            <InputNumber
                value={~~angle}
                precision={precision}
                min={min}
                max={max}
                style={{ width: 40 }}
                showStepBtn={false}
                onFocus={() => setIsActive(true)}
                onBlur={() => setIsActive(false)}
                onChange={(angle) => {
                    if (angle === null) return;
                    if (!isActive) setIsActive(true);
                    onAdjustAngle(angle);
                }}
                onChangeAfter={(angle) => {
                    if (angle === null) return;
                    setIsActive(false);
                    onAdjustAngleAfter(angle);
                }}
            />
        </div>
    );
};

export default React.memo(AngleInputGroup);
